import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SousTraitanceOui } from '../models/SousTraitanceOui';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';
import { CTRL_334 } from '../../../validators/334/ctrl334';

@Component({
  selector: 'app-sous-traitance-oui',
  templateUrl: './sous-traitance-oui.component.html'
})
export class SousTraitanceOuiComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'SousTraitanceOui';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() sousTraitanceOui: SousTraitanceOui;
  @Input() index = 0;
  public rg1 = CTRL_334.id + '_';
  public step5 = new Step5();

  public valeurSsTraitance = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_valeur';
  public monnaieSsTraitance = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_devise';
  public pourcentageSsTraitance = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partPct';
  public inconnueSsTraitance = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partInconnue';
  public valeurSsTraitanceIndex = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_valeur';
  public monnaieSsTraitanceIndex = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_devise';
  public pourcentageSsTraitanceIndex = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partPct';
  public inconnueSsTraitanceIndex = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partInconnue';

  constructor() {
  }

  public ngOnInit() {
    if (this.sousTraitanceOui == null) this.sousTraitanceOui = new SousTraitanceOui();
    this.parentForm.addControl(this.getStepId() + this.rg1 + this.index, new FormControl({ rgCtrls: this.getCtrl_334Names_json(this.index) }));
  }

  public getCtrl_334Names_json(index = 0): any {
    return index == 0 ? {
        valeur: this.valeurSsTraitance,
        monnaie: this.monnaieSsTraitance,
        pourcentage: this.pourcentageSsTraitance,
        inconnue: this.inconnueSsTraitance
    } : {
        valeur: this.valeurSsTraitanceIndex.replace("INDEX", index.toString()),
            monnaie: this.monnaieSsTraitanceIndex.replace("INDEX", index.toString()),
            pourcentage: this.pourcentageSsTraitanceIndex.replace("INDEX", index.toString()),
            inconnue: this.inconnueSsTraitanceIndex.replace("INDEX", index.toString())
    };
  }


  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  public getUidTypeMontant() {
    return this.getUid() + '_SepSep_TypeMontant';
  }

  public ngOnDestroy() {
    this.parentForm.removeControl(this.getStepId() + this.rg1 + this.index);
  }

}
